import { z } from "zod";

import { savInterventionsSchema } from "./sections/interventions.js";
import { savConclusionSchema } from "./sections/conclusion.js";

/**
 * Payload SAV, tolérant : un brouillon peut manquer de n'importe quelle
 * section. La complétude est vérifiée à part (./validation.ts), au moment de
 * soumettre. Pas de section « contexte » : client, adresse et demande sont
 * déjà portés par la tâche, on ne les ressaisit pas.
 */
export const SAV_PAYLOAD_VERSION = 1 as const;

export const savPayloadSchema = z
  .object({
    version: z.literal(SAV_PAYLOAD_VERSION).optional(),
    interventions: savInterventionsSchema.optional(),
    conclusion: savConclusionSchema.optional(),
  })
  .partial();

export type SavPayload = z.infer<typeof savPayloadSchema>;

export const emptySavPayload = (): SavPayload => ({
  version: SAV_PAYLOAD_VERSION,
});
